/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
} from 'class-validator';

export function MaxFundedBeds(
  fundedGetter: (o: any) => number,
  validationOptions?: ValidationOptions
) {
  return function (object: any, propertyName: string) {
    registerDecorator({
      name: 'MaxFundedBeds',
      target: object.constructor,
      propertyName,
      constraints: [fundedGetter],
      options: validationOptions,
      validator: {
        validate(value: any, args: ValidationArguments) {
          if (value == null) return true;

          const o = args.object as any;
          const getter = args.constraints[0] as (o: any) => number;
          const fundedBeds = getter(o);

          if (typeof fundedBeds !== 'number') return true;

          return value <= fundedBeds;
        },

        defaultMessage(args: ValidationArguments) {
          const o = args.object as any;
          const getter = args.constraints[0] as (o: any) => number;
          const fundedBeds = getter(o);

          return `${args.property} cannot exceed fundedBeds (${fundedBeds})`;
        },
      },
    });
  };
}
